import { Component } from "react";

export interface navProps {
  scrollPosition: number;
  dropDownClosed: boolean;
}

export enum linkTypes {
  desktop = "desktopList",
  mobile = "mobileList",
  footer = "footerList"
}

export interface linkProps {
  displayStyle: linkTypes.desktop | linkTypes.mobile | linkTypes.footer;
  slideDownAnimation: boolean;
  closed?: boolean;
  isSticky?: boolean;
  activeColor: string;
  onClick?: () => void;
}

export interface carouselProps {
  carouselIndex: number;
  nextIndex: number;
  fading: string;
  inTransition: boolean;
}

export interface slideProps {
  imageURL: string;
  nextImageURL: string;
  fading: string;
}

export interface arrowProps {
  direction: string;
  icon: string;
  clickFunction: () => void;
}

export interface pileProps {
  width: number;
  height: number;
}

export interface serviceProps {
  logo: JSX.Element;
  image: string;
  title: string;
  description: string;
}
